export interface ClientProps {
  id: string;
  name: string;
  slug: string;
  logoUrl: string;
  websiteUrl?: string | null;
  category?: string | null;
  status: string;
  displayOrder: number;
}

export class ClientEntity {
  constructor(private readonly props: ClientProps) {
    if (!props.id) throw new Error('El ID de cliente es obligatorio');
    if (!props.name) throw new Error('El nombre de cliente es obligatorio');
    if (!props.slug) throw new Error('El slug de cliente es obligatorio');
    if (!props.logoUrl) throw new Error('El logo del cliente es obligatorio');
  }

  get id(): string {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get slug(): string {
    return this.props.slug;
  }

  get logoUrl(): string {
    return this.props.logoUrl;
  }

  get websiteUrl(): string | undefined | null {
    return this.props.websiteUrl;
  }

  get category(): string | undefined | null {
    return this.props.category;
  }

  get status(): string {
    return this.props.status;
  }

  get displayOrder(): number {
    return this.props.displayOrder;
  }

  toJSON(): ClientProps {
    return { ...this.props };
  }
}
